import Tooltip, { tooltipClasses, TooltipProps } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import palette from "../../styles/palette";

interface CustomTooltipProps extends TooltipProps {
  backgroundColor?: string;
}

const CustomTooltip = styled(
  ({
    className,
    backgroundColor,
    disableInteractive = true,
    ...props
  }: CustomTooltipProps) => (
    <Tooltip
      disableInteractive={disableInteractive}
      {...props}
      classes={{ popper: className }}
    />
  )
)(({ theme, backgroundColor }: { theme: any; backgroundColor?: string }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: backgroundColor ? backgroundColor : undefined,
    backgroundImage: backgroundColor
      ? undefined
      : `radial-gradient(
      circle,
      ${palette.primary.main} 0%,
      ${palette.primary.dark} 100%
    )`,
    boxShadow: theme.shadows[1],
    color: "white",
    padding: "0.3rem",
  },
}));

export default CustomTooltip;
